import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-75348264")

_pushScopeId("data-v-75348264")
const _hoisted_1 = { class: "color_selection_container" }
const _hoisted_2 = {
  key: 0,
  class: "selected_image"
}
const _hoisted_3 = { class: "uk-child-width-1-3 uk-width-3-4" }
const _hoisted_4 = { class: "color_selected_base" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "color_area" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lottie = _resolveComponent("lottie")
  const _component_DemoModal = _resolveComponent("DemoModal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.chosen)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("img", {
              src: _ctx.imageSelect1,
              alt: ""
            }, null, 8, ["src"]),
            _createVNode("img", {
              src: _ctx.imageSelect2,
              alt: ""
            }, null, 8, ["src"]),
            _createVNode("img", {
              src: _ctx.imageSelect3,
              alt: ""
            }, null, 8, ["src"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      _createVNode("img", {
        src: _ctx.base,
        alt: "color__base"
      }, null, 8, ["src"])
    ]),
    (_ctx.animChoice != -1)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (color, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: "color_transit_anim"
            }, [
              (_ctx.choice == index)
                ? (_openBlock(), _createBlock(_component_lottie, {
                    key: 0,
                    options: color.lottieImage,
                    onAnimCreated: _ctx.handleAnimation
                  }, null, 8, ["options", "onAnimCreated"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (color, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: "color_selected uk-width-3-4",
          onClick: ($event: any) => (_ctx.select(index))
        }, null, 8, ["onClick"]))
      }), 128))
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.innerSteps, (innerStep, index) => {
      return (_openBlock(), _createBlock(_component_DemoModal, {
        key: index,
        delayed: innerStep.delayed,
        modal: _ctx.checkInnerStep(innerStep.stepNum),
        title: innerStep.title,
        subtexts: innerStep.subtexts,
        moveonEnd: innerStep.moveonEnd,
        onModalClosed: _ctx.close
      }, null, 8, ["delayed", "modal", "title", "subtexts", "moveonEnd", "onModalClosed"]))
    }), 128))
  ]))
})